module.exports = __webpack_public_path__ + "static/media/projects-banner.8966016d.png";